/* =========================================================================
   BlincSync — product page
   Variant selection and the gallery. Loaded only on the product template.

   The form is a real <form> with radio inputs, so everything here is an
   upgrade on top of working no-JS behaviour, not a replacement for it.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-product-form]');
  if (!root) return;

  var theme = window.BlincSync || {};
  var strings = (theme.config && theme.config.strings) || {};

  /* ---------------------------------------------------------------- gallery */

  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;

    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));

    function show(mediaId) {
      var found = false;
      slides.forEach(function (slide) {
        var match = slide.getAttribute('data-gallery-slide') === String(mediaId);
        slide.classList.toggle('is-active', match);
        if (match) found = true;
      });
      /* A variant can point at media that isn't in the gallery (rare, but it
         happens with deleted images) — leave the current slide alone then. */
      if (!found) return;

      thumbs.forEach(function (thumb) {
        thumb.setAttribute(
          'aria-current',
          String(thumb.getAttribute('data-gallery-thumb') === String(mediaId))
        );
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(thumb.getAttribute('data-gallery-thumb'));
      });
    });

    /* Arrow keys move through the thumbnail rail, per the tablist pattern. */
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = thumbs[index + 1];
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = thumbs[index - 1];
        if (!next) return;
        event.preventDefault();
        next.focus();
        next.click();
      });
    });

    return show;
  }

  /* --------------------------------------------------------------- variants */

  function initVariants(showMedia) {
    var dataEl = root.querySelector('[data-variant-data]');
    if (!dataEl) return; /* single-variant product — nothing to switch */

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add-button]');
    var addText = root.querySelector('[data-add-text]');
    var priceWrap = document.querySelector('.pdp__price-row .price');
    var stockEl = document.querySelector('[data-stock]');
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-input]'));

    function selectedOptions() {
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
      return groups.map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return (
        variants.filter(function (variant) {
          return options.every(function (value, index) {
            return variant.options[index] === value;
          });
        })[0] || null
      );
    }

    /* Combinations that don't exist, or exist but are sold out, are struck
       through before the shopper commits to them — Shopify's convention, and
       far better than an error at add-to-cart. */
    function markAvailability(options) {
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));

      groups.forEach(function (group, groupIndex) {
        Array.prototype.slice.call(group.querySelectorAll('.variant-option')).forEach(function (label) {
          var input = label.querySelector('input');
          var span = label.querySelector('span');
          var probe = options.slice();
          probe[groupIndex] = input.value;

          var candidates = variants.filter(function (variant) {
            return probe.every(function (value, index) {
              return index === groupIndex ? variant.options[index] === input.value : variant.options[index] === value;
            });
          });

          var reachable = candidates.some(function (variant) {
            return variant.available;
          });
          span.classList.toggle('is-unavailable', !reachable);
        });
      });
    }

    function updateUrl(variant) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function render(variant) {
      var options = selectedOptions();

      /* Echo the chosen value next to each option label. */
      options.forEach(function (value, index) {
        var label = root.querySelector('[data-option-value="' + index + '"]');
        if (label && value) label.textContent = value;
      });

      markAvailability(options);

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = strings.unavailable || 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;
      updateUrl(variant);

      if (priceWrap && theme.formatMoney) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap.classList.toggle('price--on-sale', Boolean(onSale));

        var current = priceWrap.querySelector('.price__current');
        if (current) current.textContent = theme.formatMoney(variant.price);

        var compare = priceWrap.querySelector('.price__compare');
        if (onSale) {
          if (!compare) {
            compare = document.createElement('s');
            compare.className = 'price__compare';
            priceWrap.appendChild(compare);
          }
          compare.textContent = theme.formatMoney(variant.compare_at_price);
        } else if (compare) {
          compare.remove();
        }
      }

      if (addButton && addText) {
        addButton.disabled = !variant.available;
        addText.textContent = variant.available
          ? strings.addToCart || 'Add to cart'
          : strings.soldOut || 'Sold out';
      }

      if (stockEl) {
        stockEl.className = 'stock ' + (variant.available ? 'stock--in' : 'stock--out');
        stockEl.textContent = variant.available
          ? stockEl.getAttribute('data-in-label') || 'In stock'
          : strings.soldOut || 'Sold out';
      }

      if (variant.featured_media && showMedia) showMedia(variant.featured_media.id);

      /* Broadcast so anything outside this panel — the sticky bar — can follow
         without product.js needing to know it exists. */
      document.dispatchEvent(new CustomEvent('variant:change', { detail: variant }));
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        render(findVariant(selectedOptions()));
      });
    });

    /* Paint availability on load so sold-out combinations are struck through
       before the first click, not after it. */
    markAvailability(selectedOptions());
  }

  var showMedia = initGallery();
  initVariants(showMedia);
})();
